// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"8a6620a4","9777":"4a3de216"}[chunkId] + ".js";
};